/** ₦5,000 — grouped, with the naira sign the comps use. */
export function naira(minor: number): string {
  return `₦${(minor / 100).toLocaleString("en-NG")}`;
}

/** Seconds → `32:14`. Minutes are not padded; seconds always are. */
export function clock(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safe / 60);
  return `${minutes}:${String(safe % 60).padStart(2, "0")}`;
}

/** The single all-access price, mirrored from the backend's PRICING_CONFIG. */
export const ALL_ACCESS_MINOR = 500_000;
